/**
 * @generated SignedSource<<4c945bf6adc7cad563044cc884bfac3f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuInputRangeCurrency_filters$data = {
  readonly values: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuInputRange_filterValue">;
  } | null> | null;
  readonly " $fragmentType": "SbSharedRefineMenuInputRangeCurrency_filters";
};
export type SbSharedRefineMenuInputRangeCurrency_filters$key = {
  readonly " $data"?: SbSharedRefineMenuInputRangeCurrency_filters$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuInputRangeCurrency_filters">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuInputRangeCurrency_filters",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseFilterValue",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedRefineMenuInputRange_filterValue"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SearchBrowseFilter",
  "abstractKey": null
};

(node as any).hash = "bedfdc545a485c96bc47e33f69c36dcb";

export default node;
